export function hasDataKitBeta(member: unknown): boolean {
  return !!(member as { dataKitBeta?: boolean } | null)?.dataKitBeta;
}

/** Account admins - the only members who create, edit or import item libraries. */
export function canManageItemLibraries(member: unknown): boolean {
  const m = member as { owner?: boolean; role?: string } | null;
  return !!m && (!!m.owner || m.role === "Admin");
}
